import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Link as RouterLink, Navigate, Route, Routes,} from 'react-router-dom';
import {
    AppBar,
    Box,
    Button,
    Container,
    CssBaseline,
    createTheme,
    ThemeProvider,
    Toolbar,
    Typography,
} from '@mui/material';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SurveyEditor from './pages/SurveyEditor';
import {setAuthToken} from './api';

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            setAuthToken(token); // Set token on initial app load
            setIsAuthenticated(true);
        }
        setIsLoading(false);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        setAuthToken(null); // Clear the token from axios headers
        setIsAuthenticated(false);
    };

    // A simple private route component
    const PrivateRoute = ({children}) => {
        if (isLoading) return <Typography>Loading...</Typography>;
        return isAuthenticated ? children : <Navigate to="/login"/>;
    };

    return (
        <ThemeProvider theme={darkTheme}>
            <CssBaseline/>
            <Router>
                <AppBar position="static">
                    <Toolbar>
                        <Box
                            component="img"
                            sx={{height: 40, mr: 2}}
                            alt="Surveyatorium Logo"
                            src="/logo192.png"
                        />
                        <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                            Surveyatorium
                        </Typography>
                        {isAuthenticated && (
                            <>
                                <Button color="inherit" component={RouterLink} to="/">
                                    Dashboard
                                </Button>
                                <Button color="inherit" onClick={handleLogout}>
                                    Logout
                                </Button>
                            </>
                        )}
                    </Toolbar>
                </AppBar>
                <Container>
                    <Box mt={4}>
                        <Routes>
                            <Route
                                path="/login"
                                element={<Login setAuth={setIsAuthenticated}/>}
                            />
                            <Route
                                path="/"
                                element={<PrivateRoute><Dashboard/></PrivateRoute>}
                            />
                            <Route
                                path="/survey/new"
                                element={<PrivateRoute><SurveyEditor/></PrivateRoute>}
                            />
                            <Route
                                path="/survey/:id"
                                element={<PrivateRoute><SurveyEditor/></PrivateRoute>}
                            />
                            <Route
                                path="*"
                                element={<Navigate to="/"/>}
                            />
                        </Routes>
                    </Box>
                </Container>
            </Router>
        </ThemeProvider>
    );
}

export default App;